<header>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-6">
        <div class="d-flex">
          <div class="logo">
            <img src="assets/images/logo.png" alt="logo" class="logo" />
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6">
        <div class="header_nav">
          <div class="hCard">
            <div class="avatar" [style.background-color]="'rgb(' + bgColor + ')'">{{avatar}}</div>
            <p>{{ username }}</p>
          </div>
          <button (click)="toggleFullscreen()" class="btn hCard">
            <i class="mdi" [ngClass]="{
                'mdi-fullscreen': !isFullscreen,
                'mdi-fullscreen-exit': isFullscreen
              }"></i>
          </button>
          <div class="hCard">
            <span class="mdi mdi-power" (click)="logout()"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<section class="main-body">
  <div class="container-fluid">
    <div class="row flex-nowrap">

      @if(moduleData !== null){
      <div class="close-sidebar" (click)="toggle()">
        <span class="mdi mdi-chevron-left"></span>
      </div>
      <div class="col-auto col-md-3 col-xl-2 p-xxl-2 sideNav">
        <div class="sideNav-flex">
          <nav class="navbar navbar-vertical navbar-expand-lg">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarVerticalCollapse" aria-controls="navbarsExample03" aria-expanded="false"
              aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="res-navLogo">
              <div class="logo">
                <img src="assets/images/logo.png" alt="logo" class="logo" />
              </div>
            </div>
            <div class="res-nav">
              <div class="header_nav">
                <div class="hCard">
                  <img src="assets/images/face.png" alt="img" />
                  <p>{{ username }}</p>
                </div>
                <button (click)="toggleFullscreen()" class="btn hCard">
                  <i class="mdi" [ngClass]="{
                    'mdi-fullscreen': !isFullscreen,
                    'mdi-fullscreen-exit': isFullscreen
                  }"></i>
                </button>
                <div class="hCard">
                  <span class="mdi mdi-power" (click)="logout()"></span>
                </div>
              </div>
            </div>
            <div class="collapse navbar-collapse w-100" id="navbarVerticalCollapse">
              <div class="navbar-vertical-content w-100">
                <ul class="navbar-nav flex-column w-100" id="navbarVerticalNav">
                  @if(moduleCategory.includes('project') || !isAiAdmin){
                  <li class="nav-item">
                    <div class="nav-item-wrapper">
                      <a class="nav-link dropdown-toggle" href="#nv-home" data-bs-toggle="collapse"
                        [ngClass]="{'active': childSet.isActive}">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-indicator-icon">
                            <i class="mdi mdi-file"></i>
                          </div>
                          <span class="ms-1">Project</span>
                        </div>
                      </a>
                      <div class="parent-wrapper label-1">
                        <ul class="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" routerLinkActive="show"
                          #childSet="routerLinkActive" id="nv-home">
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/list">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Project List</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/information">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Project Information</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/resourceManagement">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Infra Management</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/releaseManagement">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Release Management</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/reldashboard">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Release Dashboard</span>
                              </div>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/costOptimize">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Azure Cost Dashboard</span>
                              </div>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/migpthDashboard">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">MigrationPath Dashboard</span>
                              </div>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/pgDashboard">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Azure Performance Dashboard</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/workload">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">WorkLoads</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/leadership-dashboards">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">LeaderShip Dashboard</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/connectors">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Connector Agent</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/release-agent">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Release Agent</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/voice-over-agent">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Voice Over Agent</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/project/benchmark">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Benchmark</span>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  }
                  @if(moduleCategory.includes('client') || !isAiAdmin){
                  <li class="nav-item">
                    <div class="nav-item-wrapper">
                      <a class="nav-link dropdown-toggle" href="#nv-home1" data-bs-toggle="collapse"
                        [ngClass]="{'active': childSet1.isActive}">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-indicator-icon">
                            <i class="mdi mdi-account"></i>
                          </div>
                          <span class="ms-1">Client</span>
                        </div>
                      </a>
                      <div class="parent-wrapper label-1">
                        <ul class="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" routerLinkActive="show"
                          #childSet1="routerLinkActive" id="nv-home1">
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/client/home">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Home</span>
                              </div>
                            </a>
                          </li>
                          @if(sharedStateService.sharedValue() || showThis){
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/client/contacts">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Contacts</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/client/documents">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Documents</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/client/discovery">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Discovery</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/client/projects">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Projects</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/client/userManagement">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">User Management</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/client/userRoles">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">User Roles</span>
                              </div>
                            </a>
                          </li>
                          }
                        </ul>
                      </div>
                    </div>
                  </li>
                  }
                  @if(moduleCategory.includes('administration') && showAdmin || !isAiAdmin){
                  <li class="nav-item">
                    <div class="nav-item-wrapper">
                      <a class="nav-link dropdown-toggle" href="#nv-home-roles" data-bs-toggle="collapse"
                        [ngClass]="{'active': childSet.isActive}">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-indicator-icon">
                            <i class="mdi mdi-file"></i>
                          </div>
                          <span class="ms-1">Roles</span>
                        </div>
                      </a>
                      <div class="parent-wrapper label-1">
                        <ul class="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" routerLinkActive="show"
                          #childSet="routerLinkActive" id="nv-home-roles">
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/userManagement">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">User Management</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/userRoles">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">User Roles</span>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  }
                  @if(moduleCategory.includes('administration') && showAdmin || !isAiAdmin){
                  <li class="nav-item">
                    <div class="nav-item-wrapper">
                      <a class="nav-link dropdown-toggle" href="#nv-home2" data-bs-toggle="collapse"
                        [ngClass]="{'active': childSet2.isActive}">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-indicator-icon">
                            <i class="mdi mdi-account-lock"></i>
                          </div>
                          <span class="ms-1">Admin</span>
                        </div>
                      </a>
                      <div class="parent-wrapper label-1">
                        <ul class="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" routerLinkActive="show"
                          #childSet2="routerLinkActive" id="nv-home2">
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/clientOnBoarding">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Client Onboarding</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/clientManagement">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Client Management</span>
                              </div>
                            </a>
                          </li>
                          <!-- <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/userManagement">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">User Management</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/userRoles">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">User Roles</span>
                              </div>
                            </a>
                          </li> -->
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/projectList">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Project Management</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/imageManagement">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Image Management</span>
                              </div>
                            </a>
                          </li>

                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/licenseKeys">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">License Keys</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/acrAccess">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">ACR Access</span>
                              </div>
                            </a>
                          </li>
                          <!-- <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/dnaMapping">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">DNS Mapping</span>
                              </div>
                            </a>
                          </li> -->
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/addOrganization">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Add Organization</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/addProjectCategory">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Add Project Category</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/gitCopy">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Git Copy</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/repoApproval">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Repo Approval</span>
                              </div>
                            </a>
                          </li>
                          <!-- <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/admin/vacuum">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Vacuum</span>
                              </div>
                            </a>
                          </li> -->
                        </ul>
                      </div>
                    </div>
                  </li>
                  }

                  @if(moduleCategory.includes('administration') && isAiAdmin){
                  <li class="nav-item">
                    <div class="nav-item-wrapper">
                      <a class="nav-link dropdown-toggle" href="#nv-home3" data-bs-toggle="collapse"
                        [ngClass]="{'active': childSet3.isActive}">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-indicator-icon">
                            <i class="mdi mdi-account-cowboy-hat"></i>
                          </div>
                          <span class="ms-1">AI Admin</span>
                        </div>
                      </a>
                      <div class="parent-wrapper label-1">
                        <ul class="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" routerLinkActive="show"
                          #childSet3="routerLinkActive" id="nv-home3">
                          <!-- <li class="nav-item">
                              <a class="nav-link" routerLinkActive="active" routerLink="/aiAdmin/keyAreas">
                                <div class="d-flex align-items-center">
                                  <span class="nav-link-text">Key Areas</span>
                                </div>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" routerLinkActive="active" routerLink="/aiAdmin/migrationScenarios">
                                <div class="d-flex align-items-center">
                                  <span class="nav-link-text">Migration Scenarios</span>
                                </div>
                              </a>
                            </li> -->
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/ai-admin/migration-scenarios">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Migrations</span>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  }
                  @if(moduleCategory.includes('administration') && showAdmin || !isAiAdmin){
                  <li class="nav-item">
                    <div class="nav-item-wrapper">
                      <a class="nav-link dropdown-toggle" href="#nv-home7" data-bs-toggle="collapse"
                        [ngClass]="{'active': childSet7.isActive}">
                        <div class="d-flex align-items-center">
                          <div class="dropdown-indicator-icon">
                            <i class="mdi mdi-account-lock"></i>
                          </div>
                          <span class="ms-1">DBA</span>
                        </div>
                      </a>
                      <div class="parent-wrapper label-1">
                        <ul class="nav collapse parent" data-bs-parent="#navbarVerticalCollapse" routerLinkActive="show"
                          #childSet7="routerLinkActive" id="nv-home7">

                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/dba/agent">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Agent</span>
                              </div>
                            </a>
                          </li>
                          <!-- <li class="nav-item">
                              <a class="nav-link" routerLinkActive="active" routerLink="/dba/project-databases" target="_blank">
                                <div class="d-flex align-items-center">
                                  <span class="nav-link-text">DBA Dashboard</span>
                                </div>
                              </a>
                            </li> -->
                          <li class="nav-item">
                            <a class="nav-link" href="https://dvqcam.qmigrator.ai/ai/dba/dashboard" target="_blank">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">DBA Dashboard</span>
                              </div>
                            </a>
                          </li>
                          <!-- <li class="nav-item">
                              <a class="nav-link" routerLinkActive="active" routerLink="/dba/roles">
                                <div class="d-flex align-items-center">
                                  <span class="nav-link-text">Roles</span>
                                </div>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" routerLinkActive="active" routerLink="/dba/users">
                                <div class="d-flex align-items-center">
                                  <span class="nav-link-text">Users</span>
                                </div>
                              </a>
                            </li> -->
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/dba/permissions">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Permissions</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/dba/bloating">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Bloating</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/dba/vacuum">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Vacuum Analyze</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/dba/Healthcheckreport">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Health Check report</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/dba/dba-monitoring">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">DBA Monitoring</span>
                              </div>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" routerLinkActive="active" routerLink="/dba/reports">
                              <div class="d-flex align-items-center">
                                <span class="nav-link-text">Reports</span>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  }
                  <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/repoRequest">
                      <i class="mdi mdi-git"></i>
                      <span class="ms-1">Repo Request</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/tryNow">
                      <i class="mdi mdi-web-refresh"></i>
                      <span class="ms-1">Web Try Now</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" routerLink="/settings">
                      <i class="mdi mdi-cogs"></i>
                      <span class="ms-1">Settings</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="res-navHelp">
                <div class="help_center">
                  <h3>Help Center</h3>
                  <div class="help_cd">
                    <p>Having trouble in Migration Please contact us for more questions</p>
                    <button class="btn btn-upload">Go to Help Center</button>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
      }@else{
      <div class="text-center mt-3">
        <h5>Please check with Admin </h5>
      </div>
      }
    </div>
  </div>
</section>